/**
 * @generated SignedSource<<220ac9f9cc93376ec7bdec0c17caadff>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NodeEventAction = "CREATED" | "REMOVED" | "UPDATED" | "%future added value";
export type useNodeEventsSubscription$variables = {
  nodeID: string;
};
export type useNodeEventsSubscription$data = {
  readonly nodeEvents: {
    readonly action: NodeEventAction;
    readonly nodeID: string;
  };
};
export type useNodeEventsSubscription = {
  response: useNodeEventsSubscription$data;
  variables: useNodeEventsSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "nodeID",
    "variableName": "nodeID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "action",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useNodeEventsSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeEvents",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useNodeEventsSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeEvents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2a9005363c5d562016d1a5dae43caa9a",
    "id": null,
    "metadata": {},
    "name": "useNodeEventsSubscription",
    "operationKind": "subscription",
    "text": "subscription useNodeEventsSubscription(\n  $nodeID: ID!\n) {\n  nodeEvents(nodeID: $nodeID) {\n    __typename\n    action\n    nodeID\n  }\n}\n"
  }
};
})();

(node as any).hash = "5d149b4f316de42b30ca573d0c3481b4";

export default node;
